import { useCallback, useState } from 'react';
import { Loadable, PrepareRemoteQrCodeForSharing } from '../types';

/**
 * On native, this hook prepares a remote URL for sharing by downloading it to a temporary file. The file path is
 * returned to the caller, who can then share it via react-native-share.
 *
 * On web, this hook is a no-op and returns the URL as-is.
 */
export function usePrepareRemoteFileForSharing(): PrepareRemoteQrCodeForSharing {
  const [response, setResponse] = useState<Loadable<string> | undefined>();

  const prepareRemoteFileForSharing = useCallback(
    (url: string) => {
      setResponse({ state: 'success', data: url });
    },
    [setResponse],
  );

  return { response, prepareRemoteFileForSharing };
}
